import React from 'react'

import Hero from '~/components/core/hero'
import PushPreview from '~/components/features/edito/pushPreview'
import SlicesWrapper from '~/components/slices/slicesWrapper'
import PushContent from '~/components/core/pushContent'

import getProfileHeroColor from '~/utils/getProfileHeroColor'

const PageLayout = ({ data, currentUrl, furtherContent }) => {
  const isMediaLibrary = data.customType === 'Médiathèque'
  const isBlog = data.customType === 'Blog'
  const bgColor = getProfileHeroColor('blue', data.profile)

  return (
    <div className={`w-full ${data.mainImage ? '' : 'pt-18 md:pt-26'}`}>
      <Hero
        currentUrl={currentUrl}
        data={data}
        bgColor={isMediaLibrary ? 'medium-purple' : bgColor}
        type="page"
        customType={isMediaLibrary ? 'Médiathèque' : isBlog ? 'Blog' : null}
      />

      <div className="fluid-grid">
        <div className={`row relative ${isMediaLibrary ? 'pt-2 pb-6' : ''}`}>
          <SlicesWrapper isMediaLibrary={isMediaLibrary} slices={data.slices} />
          <div className="hidden lg:block lg-col-4 xl-col-3 md:pt-14 md:pb-10 page-sidebar">
            {!isMediaLibrary &&
              (furtherContent?.nodes?.length > 0 ||
                data.pushPages !== null) && (
                <PushPreview
                  items={data.pushPages}
                  autoItems={furtherContent}
                />
              )}
          </div>
        </div>
        {(furtherContent?.nodes?.length > 0 || data.pushPages !== null) && (
          <PushContent
            data={data.pushPages}
            autoItems={furtherContent}
            type="inner"
          />
        )}
      </div>
    </div>
  )
}

export default PageLayout
